/** Минуты → ISO 8601 только из часов и минут, как требует API v2: 90 → `PT1H30M`, 480 → `PT8H` */
export const formatDurationIso = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;

  return `PT${hours ? `${hours}H` : ''}${rest || !hours ? `${rest}M` : ''}`;
};
